var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgOtherDeviceIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5C16.5 11.7427 15.4926 12.75 14.25 12.75H3.75C2.50733 12.75 1.5 11.7427 1.5 10.5V4.5C1.5 3.25736 2.50733 2.25 3.75 2.25H14.25C15.4926 2.25 16.5 3.25736 16.5 4.5V10.5Z",
    fill: "#03002F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.75H12C12.4142 15.75 12.75 15.4142 12.75 15C12.75 14.5858 12.4142 14.25 12 14.25H6C5.58578 14.25 5.25 14.5858 5.25 15C5.25 15.4142 5.58578 15.75 6 15.75Z",
    fill: "#C59331"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOtherDeviceIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/otherDeviceIcon.c4edfe71b244d7a4241f4c5c0fe755fa.svg";